import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
  computed,
  inject,
} from '@angular/core';
import { ChevronDownIconComponent } from '@kuiper/icons';
import { AvatarComponent } from '../../../../../ui-components/lib/avatar/avatar.component';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'lib-profile-dropdown-button',
  imports: [AvatarComponent, ChevronDownIconComponent],
  templateUrl: './profile-dropdown-button.component.html',
  styleUrl: './profile-dropdown-button.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDropdownButtonComponent {
  private readonly authService = inject(AuthService);

  isOpen = input.required<boolean>();
  toggleDropdown = output<void>();

  user = this.authService.user;
  centralUser = this.authService.centralUser;
  selectedWorkspace = this.authService.selectedWorkspace;

  userName = computed(
    () =>
      this.user()?.name ??
      this.centralUser()?.first_name + ' ' + this.centralUser()?.last_name
  );
  userImage = computed(() => this.centralUser()?.image?.url);

  handleDropdownToggle() {
    this.toggleDropdown.emit();
  }
}
